import { OptimizelyContext } from '@optimizely/react-sdk';
import { useContext } from 'react';
var getIsCampaignIdEnabled = function getIsCampaignIdEnabled(optimizely, campaignId) {
  if (!(optimizely !== null && optimizely !== void 0 && optimizely.isReady)) {
    return false;
  }
  var decision = optimizely.decide('coupon_campaigns');
  var campaignNames = decision.variables.campaignNames;
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return campaignNames === null || campaignNames === void 0 ? void 0 : campaignNames.names.includes(campaignId);
};

/**
 * Hook to return boolean if campaignId is part of the variables array
 * @param campaignId
 * @returns true or false if campaignId is part of variables array
 */
var useIsCampaignIdEnabled = function useIsCampaignIdEnabled(campaignId) {
  var _useContext = useContext(OptimizelyContext),
    optimizely = _useContext.optimizely;
  return getIsCampaignIdEnabled(optimizely, campaignId);
};
export default useIsCampaignIdEnabled;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/hooks/useIsCampaignIdEnabled.js
// module id = 1429
// module chunks = 11